import { createSlice, PayloadAction, createAsyncThunk  } from '@reduxjs/toolkit'
import { getInfluencersTrackingLinksData } from '../../../../utils/requestsUtils/functionsRequests/TrackingLinks/trackingLinksFunctions'

export type OperativeSystemsCount = {
    count: number
    operative_system: string
} 

export type InfluencerDataCount = {
    id: string
    name: string
    active: boolean
    operative_systems: OperativeSystemsCount[]
}

export type InfluencerDataRow = {
    id:                 number
    id_track:           string
    date:               string
    device:             string
    operative_system:   string
}

export type InlfuencerData = {
    influencerDataCount: InfluencerDataCount[]
    dataRow: InfluencerDataRow[]
}



export const GetTrackingLinksInfluencersThunk = createAsyncThunk(
    'TrackingLinksInfluencers/GetTrackingLinksInfluencersThunk',
    async () => {
      try { 

          const results = await getInfluencersTrackingLinksData()
    
          return {
            data: results
          }
      } catch (error) {
          console.log("error", error)
          return {
            data: {} as InlfuencerData
          }
      }
    }
)

type InitialState = {
    loading: boolean,
    influencersData: InlfuencerData
}

const initialState: InitialState = {
    loading: false,
    influencersData: {
        influencerDataCount: [],
        dataRow: []
    }
}

export const trackingLinksInfluencersSlice = createSlice({
    name: 'trackingLinksInfluencers',
    initialState,
    reducers: {
        setAddTrackLinkState: (state, action: PayloadAction<InfluencerDataCount>) => {
            state.influencersData.influencerDataCount.push(action.payload)
            return state;
        },
        setDeleteTrackLinkState: (state, action: PayloadAction<string>) => {
            state.influencersData.influencerDataCount = state.influencersData.influencerDataCount.map((d) => {
                if(d.id === action.payload){
                    return {
                        ...d,
                        active: false
                    }
                }
                return d
            })
            return state;
        },
        setEditTrackLinkState: (state, action: PayloadAction<InfluencerDataCount>) => {
            state.influencersData.influencerDataCount = state.influencersData.influencerDataCount.map((d) => {
                if(d.id === action.payload.id){
                    return action.payload
                }
                return d
            })
            return state;
        },
        resetTrackingLinksReducer: () => {
            return initialState
        }
    },

    extraReducers: (builder) => {
        builder.addCase(GetTrackingLinksInfluencersThunk.fulfilled, (state, action: PayloadAction<{ data: InlfuencerData }>) => {
            const { data } = action.payload 
            state.influencersData = data
            state.loading = false
            return state
        }).addCase(GetTrackingLinksInfluencersThunk.pending, (state, action: any) => {
            state.loading = true
            return state     
        }).addCase(GetTrackingLinksInfluencersThunk.rejected, (state, action: any) => {
            return initialState
        })
    },

});

export const {  
  resetTrackingLinksReducer,
  setAddTrackLinkState,
  setEditTrackLinkState,
  setDeleteTrackLinkState
} = trackingLinksInfluencersSlice.actions

export default trackingLinksInfluencersSlice.reducer